module.exports = __webpack_public_path__ + "img/flexsale-refined-3.06899cbd.png";